import { isArray } from "lodash";

const convertToPrimitive = (str: string) => {
  if (str === "") return str;
  if (/^\d+$/.test(str)) return Number(str);
  if (str === "true") return true;
  if (str === "false") return false;
  if (str === "null") return null;
  if (str === "undefined") return undefined;

  return str;
};

/**
 * @example converting "?a=1&b=2&b=3&c=foo&d=true" or new URLSearchParams(...)
 * to { a: 1, b: [2, 3], c: "foo", d: true }
 * */
export const parseUrlSearchParamsToObject = (
  input: string | URLSearchParams,
) => {
  const value = typeof input === "string" ? new URLSearchParams(input) : input;

  return [...value.entries()].reduce((acc, keyValuePair) => {
    const [rawKey, rawValue] = keyValuePair;
    const value = convertToPrimitive(rawValue);
    const key = rawKey as keyof typeof acc;

    if (!acc.hasOwnProperty(key)) {
      (acc[key] as unknown) = value;
      return acc;
    }

    if (isArray(acc[key])) {
      (acc[key] as unknown as unknown[]) = [
        ...(acc[key] as unknown as unknown[]),
        value,
      ];
    } else {
      (acc[key] as unknown as unknown[]) = [acc[key], value];
    }

    return acc;
  }, new Object());
};
